import { Component, EventEmitter, Input, Output } from "@angular/core";
import { LeiLookup } from "src/app/models/lei/lei.lookup";

@Component({
  selector: "app-item-navegacao-favoritos",
  templateUrl: "./item-navegacao-favoritos.component.html",
  styleUrls: ["./item-navegacao-favoritos.component.scss"],
})
export class ItemNavegacaoFavoritosComponent {
  @Output() favoritoMudou = new EventEmitter<LeiLookup>();
  @Output() favoritoSelecionarLei = new EventEmitter<LeiLookup>();
  @Input() item: LeiLookup;

  constructor() {}

  public btnFavoritoClick(evt: Event): void {
    evt.stopPropagation();
    this.favoritoMudou.emit(this.item);
  }

  public selecionarLei(evt: Event): void {
    evt.stopPropagation();
    this.favoritoSelecionarLei.emit(this.item);
  }
}
